module.exports = __webpack_public_path__ + "static/media/map-marker.62554156.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-marker.svg
// module id = 1410
// module chunks = 0